// React Required
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.scss";
import store from "./store";
import Loader from "./Loader";
import Loadable from "react-loadable";
import history from "./history";
import { seekerRoutes, giverRoutes } from "./constants/routeObject";
import Navbar from "./components/header/Navbar";
import { DATA, GIVERDATA } from "./components/MyPlace/data";
import Feedback from "./components/MyPlace/Seeker/MyDashboard/Feedback";

const UnStoppable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UnStoppable" */ "./components/Home/Unstoppable"
    ),
  loading: Loader,
});

const PressRelease = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Press Release" */ "./components/Home/PressRelease"
    ),
  loading: Loader,
});

const IWD = Loadable({
  loader: () => import(/* webpackChunkName: "IWD" */ "./Pages/IWD"),
  loading: Loader,
});

const SelfAwareness = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SelfAwareness" */ "./components/MyPlace/Seeker/SelfAwareness/SelfAwareness"
    ),
  loading: Loader,
});

const Coaching = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Coaching" */ "./components/MyPlace/Seeker/Coaching/Coaching"
    ),
  loading: Loader,
});

const ComingSoon = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ComingSoon" */ "./components/MyPlace/Seeker/HappinessPillars/ComingSoon"
    ),
  loading: Loader,
});

const Progress = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Progress" */ "./components/MyPlace/Seeker/MyDashboard/Progress"
    ),
  loading: Loader,
});

const Inspiration = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Inspiration" */ "./components/MyPlace/Seeker/ISeek/Inspiration"
    ),
  loading: Loader,
});

const MyIKIGAI = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "MyIKIGAI" */ "./components/MyPlace/Seeker/HappinessPillars/MyIKIGAI"
    ),
  loading: Loader,
});

const JoinOurClub = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "JoinOurClub" */ "./components/MyPlace/Seeker/HappinessPillars/JoinOurClub"
    ),
  loading: Loader,
});

const OneOnOne = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OneOnOne" */ "./components/MyPlace/Seeker/ISeek/OneOnOne"
    ),
  loading: Loader,
});

const Resources = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Resources" */ "./components/MyPlace/Seeker/MyDashboard/Resources"
    ),
  loading: Loader,
});

const Referals = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Referals" */ "./components/MyPlace/Seeker/MyDashboard/Referals"
    ),
  loading: Loader,
});

const Workshop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Workshop" */ "./components/MyPlace/Seeker/ISeek/Workshop"
    ),
  loading: Loader,
});

const MyReports = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "MyReports" */ "./components/MyPlace/Seeker/MyDashboard/MyReports"
    ),
  loading: Loader,
});

const Transaction = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Transaction" */ "./components/MyPlace/Seeker/MyDashboard/Transaction"
    ),
  loading: Loader,
});

const Profile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Profile" */ "./components/MyPlace/Seeker/MyProfile/Profile"
    ),
  loading: Loader,
});

const JoinEcosystem = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "JoinEcosystem" */ "./components/MyPlace/Seeker/JoinEcosystem/JoinEcosystem"
    ),
  loading: Loader,
});

const CoachingDetail = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CoachingDetail" */ "./components/MyPlace/CoachingDetail"
    ),
  loading: Loader,
});

const WorkshopDetail = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "WorkshopDetail" */ "./components/MyPlace/WorkShopDetail"
    ),
  loading: Loader,
});

const ProfileG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ProfileG" */ "./components/MyPlace/Giver/ProfileG"
    ),
  loading: Loader,
});

const ProgressG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ProgressG" */ "./components/MyPlace/Giver/ProgressG"
    ),
  loading: Loader,
});

const SubmissionG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SubmissionG" */ "./components/MyPlace/Giver/SubmissionG"
    ),
  loading: Loader,
});

const ReferalsG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ReferalsG" */ "./components/MyPlace/Giver/ReferalsG"
    ),
  loading: Loader,
});

const OneOnOneG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OneOnOneG" */ "./components/MyPlace/Giver/OneOnOneG"
    ),
  loading: Loader,
});

const WorkshopG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "WorkshopG" */ "./components/MyPlace/Giver/WorkshopG"
    ),
  loading: Loader,
});

const InspirationG = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "InspirationG" */ "./components/MyPlace/Giver/InspirationG"
    ),
  loading: Loader,
});

const ProtectedRoute = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ProtectedRoute" */ "./ProtectedRoute"),
  loading: Loader,
});

const BlogDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BlogDetails" */ "./Pages/BlogDetails"),
  loading: Loader,
});

const AboutUs = Loadable({
  loader: () => import(/* webpackChunkName: "AboutUs" */ "./Pages/AboutUs"),
  loading: Loader,
});

const ServicesPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ServicesPage" */ "./Pages/ServicesPage"),
  loading: Loader,
});

const MyPlace = Loadable({
  loader: () => import(/* webpackChunkName: "MyPlace" */ "./Pages/MyPlace"),
  loading: Loader,
});

// branch = shubham
const Personalisation = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Personalisation" */ "./Pages/Personalisation"),
  loading: Loader,
});


const ResetPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ResetPassword" */ "./components/ResetPassword"
    ),
  loading: Loader,
});
const ForgotPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ForgotPassword" */ "./components/ForgotPassword"
    ),
  loading: Loader,
});
const Login = Loadable({
  loader: () => import(/* webpackChunkName: "Login" */ "./Pages/Login"),
  loading: Loader,
});

const ContactUs = Loadable({
  loader: () => import(/* webpackChunkName: "ContactUs" */ "./Pages/ContactUs"),
  loading: Loader,
});

const EventsPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "EventsPage" */ "./Pages/EventsPage"),
  loading: Loader,
});

const EventDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "EventDetails" */ "./Pages/EventDetails"),
  loading: Loader,
});

const NotFound = Loadable({
  loader: () => import(/* webpackChunkName: "NotFound" */ "./Pages/NotFound"),
  loading: Loader,
});

const Sitemap = Loadable({
  loader: () => import(/* webpackChunkName: "Sitemap" */ "./Pages/Sitemap"),
  loading: Loader,
});

const LandingPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "LandingPage" */ "./Pages/LandingPage"),
  loading: Loader,
});

const HomePage = Loadable({
  loader: () => import(/* webpackChunkName: "HomePage" */ "./Pages/HomePage"),
  loading: Loader,
});

const HomePage_2 = Loadable({
  loader: () => import(/* webpackChunkName: "HomePage" */ "./Pages/HomePage_2"),
  loading: Loader,
});

const Onboarding = Loadable({
  loader: () =>
    import(/* webpackChunkName: "Onboarding" */ "./Pages/Onboarding"),
  loading: Loader,
});

const BlogsPage = Loadable({
  loader: () => import(/* webpackChunkName: "BlogsPage" */ "./Pages/BlogsPage"),
  loading: Loader,
});

const SelfLearning = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SelfLearning" */ "./components/MyPlace/Seeker/ISeek/SelfLearning"
    ),
  loading: Loader,
});

const Leadership = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Leadership" */ "./components/MyPlace/Seeker/Leadership"
    ),
  loading: Loader,
});

const MasterPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Stress Management" */ "./components/MyPlace/Seeker/StressMgmt/index"
    ),
  loading: Loader,
});

const EmotionalEating = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Emotional Eating" */ "./components/MyPlace/Seeker/EE/Index"
    ),
  loading: Loader,
});

const Networking = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Networking" */ "./components/MyPlace/Seeker/Networking/Index"
    ),
  loading: Loader,
});

const BodyShame = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Body Shame" */ "./components/MyPlace/Seeker/BodyShame/index"
    ),
  loading: Loader,
});

const NurtureRelationship = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Nurture Relationship" */ "./components/MyPlace/Seeker/NurtureRelationships/index"
    ),
  loading: Loader,
});

const Burnouts = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Burnout" */ "./components/MyPlace/Seeker/Burnout/index"
    ),
  loading: Loader,
});

const Faliure = Loadable({
  loader: () =>
    import(
      "./components/MyPlace/Seeker/Faliure/index"
    ),
  loading: Loader,
});

const Ikigai = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Ikigai" */ "./components/MyPlace/Seeker/Ikigai/Index"
    ),
  loading: Loader,
});

const HeartBreak = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Burnout" */ "./components/MyPlace/Seeker/Heartbreak/index"
    ),
  loading: Loader,
});
const Journey = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "Journey" */ "./components/Personalisation/Journey"
    ),
  loading: Loader,
});

const ViewPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewPage" */ "./components/MyPlace/ViewPage"
    ),
  loading: Loader,
});

const NetworkingPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "NetworkingPage" */ "./Pages/Networking"
    ),
  loading: Loader,
});

const WhatsNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "WhatsNew" */ "./Pages/whatsNew"
    ),
  loading: Loader,
});

class Root extends Component {
  state = {
    scrolling: false,
  };
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.state = { hideNav: false };
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <div>
            {/* <Header /> */}
            <Navbar />
            <Switch>
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/`}
                component={HomePage_2}
              // component={HomePage}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/unstoppablewoman`}
                component={UnStoppable}
              />

              <Route
                exact
                path={`${process.env.PUBLIC_URL}/iwd`}
                component={IWD}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/aboutus`}
                component={AboutUs}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/onboarding`}
                component={Onboarding}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/services`}
                component={ServicesPage}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/forgot`}
                component={ForgotPassword}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/reset`}
                component={ResetPassword}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/blogs`}
                component={BlogsPage}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/blog-details/:blogid`}
                component={BlogDetails}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/contactus`}
                component={ContactUs}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/events`}
                component={EventsPage}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/event-details`}
                component={EventDetails}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/login`}
                component={Login}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/sitemap`}
                component={Sitemap}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/networking`}
                component={NetworkingPage}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/whats-new`}
                component={WhatsNew}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/press-release`}
                component={PressRelease}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/register`}
                component={() => (
                  <LandingPage
                    header={false}
                    title="Begin your transformation journey now."
                    wantJoin={true}
                    wantLinkedinCallBack={true}
                  />
                )}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/payment-success`}
                component={() => (
                  <LandingPage
                    header="Thank you for the payment towards the workshop. You will receive the Zoom meeting details shortly."
                    subHeader="Register to explore personalized and holistic solutions to overcome challenge across career, relationships and health."
                    megaHeader="Begin your happiness journey. Now."
                    wantJoin={false}
                    wantLinkedinCallBack={true}
                  />
                )}
              />
              <ProtectedRoute
                exact
                path={seekerRoutes.getPersonalisation}
                component={() => <Personalisation />}
              />
              <ProtectedRoute
                exact
                path={giverRoutes.getPersonalisation}
                component={() => <Personalisation />}
              />

              <MyPlace>
                <ProtectedRoute
                  exact
                  path={giverRoutes.getReferal}
                  component={() => <ReferalsG />}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.getProfile}
                  component={() => (
                    <ProfileG />
                  )}
                />

                {/* <ProtectedRoute
                  exact
                  path={giverRoutes.getProgress}
                  component={() => (
                    <ProgressG />
                  )}
                /> */}

                <ProtectedRoute
                  exact
                  path={giverRoutes.getSubmission}
                  component={() => (
                    <SubmissionG />
                  )}
                />

                {/* <ProtectedRoute
                  exact
                  path={giverRoutes.getTransaction}
                  component={() => (
                    <TransactionG />
                  )}
                /> */}

                <ProtectedRoute
                  exact
                  path={giverRoutes.getOneToOne}
                  component={() => (
                    <OneOnOneG />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.getWorkShop}
                  component={() => (
                    <WorkshopG />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.getInspiration}
                  component={() => (
                    <InspirationG />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.becomeaGiver}
                  component={() => (
                    <ViewPage data={GIVERDATA[0]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.viewMyPage}
                  component={() => (
                    <ViewPage data={GIVERDATA[1]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.editMyPage}
                  component={() => (
                    <ViewPage data={GIVERDATA[2]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.modifyServices}
                  component={() => (
                    <ViewPage data={GIVERDATA[3]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.msFree}
                  component={() => (
                    <ViewPage data={GIVERDATA[4]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.msPaid}
                  component={() => (
                    <ViewPage data={GIVERDATA[5]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.oneOnOne}
                  component={() => (
                    <ViewPage data={GIVERDATA[6]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.community}
                  component={() => (
                    <ViewPage data={GIVERDATA[7]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.getTransaction}
                  component={() => (
                    <ViewPage data={GIVERDATA[8]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.getFrenzcoinG}
                  component={() => (
                    <ViewPage data={DATA[9]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.becomeAnEvangelist}
                  component={() => (
                    <ViewPage data={DATA[7]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.sessionFeedback}
                  component={() => (
                    <ViewPage data={GIVERDATA[9]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={giverRoutes.journeySoFar}
                  component={() => (
                    <ViewPage data={GIVERDATA[10]} />
                  )}
                />


                {/* My Place Giver Pages */}

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getMyHappinessIndex}
                  component={() => (
                    <SelfAwareness />
                  )}
                />


                <ProtectedRoute
                  exact
                  path={seekerRoutes.getSeekerFeedback}
                  component={() => (
                    <Feedback />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getCoaching}
                  component={() => (
                    <Coaching />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getMyIkigai}
                  component={() => (
                    <MyIKIGAI />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getJoinOurClub}
                  component={() => (
                    <JoinOurClub />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getComingSoon}
                  component={() => (
                    <ComingSoon />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getOneToOne}
                  component={() => (
                    <OneOnOne />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getWorkShop}
                  component={() => (
                    <Workshop />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getInspiration}
                  component={() => (
                    <Inspiration />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getProgress}
                  component={() => (
                    <Progress />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getMyReports}
                  component={() => (
                    <MyReports />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getTransaction}
                  component={() => (
                    <Transaction />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getResource}
                  component={() => (
                    <Resources />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getReferal}
                  component={() => (
                    <Referals />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getProfile}
                  component={() => (
                    <Profile />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getEcoSystem}
                  component={() => (
                    <JoinEcosystem />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getCoachingDetail}
                  component={() => (
                    <CoachingDetail />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getWorkshopDetail}
                  component={() => (
                    <WorkshopDetail />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getModuleRoute}
                  component={() => (
                    <SelfLearning />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getStressMgmt}
                  component={() => (
                    <MasterPage />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getEmotionalEating}
                  component={() => (
                    <EmotionalEating />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getNetworking}
                  component={() => (
                    <Networking />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getHeartbreak}
                  component={() => (
                    <HeartBreak />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getFaliure}
                  component={() => (
                    <Faliure />
                  )}
                />
                <ProtectedRoute
                  exact
                  path={seekerRoutes.getBodyShame}
                  component={() => (
                    <BodyShame />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getBurnout}
                  component={() => (
                    <Burnouts />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getIkigai}
                  component={() => (
                    <Ikigai />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getLeadershipModule}
                  component={() => (
                    <Leadership />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getNurtureRelationship}
                  component={() => (
                    <NurtureRelationship />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getPersonalise}
                  component={() =>
                    <ViewPage data={DATA[0]} />
                  }
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getFeedback}
                  component={() =>
                    <ViewPage data={DATA[8]} />
                  }
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.journeySoFar}
                  component={() =>
                    <ViewPage data={DATA[10]} />
                  }
                />

                {/* <ProtectedRoute
                  exact
                  path={seekerRoutes.getLearningModule}
                  component={() => (
                    <ViewPage data={DATA[1]} />
                  )}
                /> */}

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getAssessments}
                  component={() => (
                    <ViewPage data={DATA[2]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.findAnExpert}
                  component={() => (
                    <ViewPage data={DATA[4]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.becomeaGiver}
                  component={() => (
                    <ViewPage data={DATA[5]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getCommunity}
                  component={() => (
                    <ViewPage data={DATA[6]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.becomeAnEvangelist}
                  component={() => (
                    <ViewPage data={DATA[7]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getHanieRoom}
                  component={() => (
                    <ViewPage data={DATA[3]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getFrenzcoinS}
                  component={() => (
                    <ViewPage data={DATA[9]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.findAJob}
                  component={() => (
                    <ViewPage data={DATA[11]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.shareAJob}
                  component={() => (
                    <ViewPage data={DATA[12]} />
                  )}
                />

                <ProtectedRoute
                  exact
                  path={seekerRoutes.getJourney}
                  component={() => (
                    <Journey />
                  )}
                />
              </MyPlace>

              <ProtectedRoute
                exact
                path={seekerRoutes.getPersonalisation}
                component={() => <Personalisation />}
              />

              {/* branch = shubham */}


              {/* ///// */}

              {/* ///// */}


              <Route path="*" component={NotFound} />
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
